


<template>
      <v-dialog max-width="94%">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn
            v-bind="activatorProps"
            color="surface-variant"
            text="Privacy Policy"
            variant="text"
          ></v-btn>
        </template>

        <template v-slot:default="{ isActive }">
          <v-card title="LWYR – Privacy Policy">
            <v-card-text>
              <div class="legal-content" v-html="termsHtml"></div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                text="Close Dialog"
                @click="isActive.value = false"
              ></v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

</template>


<script setup>
import { ref, onMounted } from 'vue'

const termsHtml = ref('')

onMounted(async () => {
  const res = await fetch('/legal/privacy/privacy_v2026_02_18.html')
  termsHtml.value = await res.text()
})
</script>










<style scoped>
.legal-content {
  font-family: Arial, sans-serif;
  line-height: 1.6;
}

:deep(.legal-content h1) {
  font-size: 28px;
  margin: 0 0 8px;
}

:deep(.legal-content h2) {
  font-size: 18px;
  margin: 26px 0 8px;
}

:deep(.legal-content p) {
  font-size: 15px;
  font-weight: 200;
  margin-bottom: 12px;
}

:deep(.legal-content ul) {
  list-style-type: disc;
  list-style-position: outside;
  padding-left: 24px;
  margin-bottom: 12px;
}

:deep(.legal-content li) {
  margin-bottom: 6px;
}
</style>

 